export const tablePagination = {
  input: {
    marginRight: 32,
    marginLeft: 8,
  },
  selectRoot: {
    marginLeft: 0,
    marginRight: 0,
  },
  select: {
    paddingRight: 24,
  },
  selectIcon: {
    top: 4,
  },
};

export const dataTablePagination = {
  toolbar: {
    padding: 0,
    '& > p:nth-child(2)': {
      '@media (max-width: 400px)': {
        display: 'none',
      },
    },
  },
  root: {
    padding: 0,
  },
};

export const dataTable = {
  responsiveStacked: {
    overflow: 'auto !important',
    overflowX: 'auto !important',
  },
  tableRoot: {
    minWidth: 360,
  },
};
